import { render } from "./AddRecipientsModal.vue?vue&type=template&id=56ef50f5&scoped=true"
import script from "./AddRecipientsModal.vue?vue&type=script&lang=js"
export * from "./AddRecipientsModal.vue?vue&type=script&lang=js"

import "./AddRecipientsModal.vue?vue&type=style&index=0&id=56ef50f5&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ef50f5"]])

export default __exports__